import React, { useEffect, useState } from "react";
import PartnerImage from "./Assets/PartnerPackage.svg"
import PartnerImageWhite from "./Assets/PartnerMustard.svg"
import Associatepartner from "./Assets/Associatepartner.svg"
import AssociatepartnerWhite from "./Assets/APBlue.svg"
import Payasugo from "./Assets/Payasugo.svg"
import PayasugoWhite from "./Assets/PayasugoWhite.svg"
import DoneIcon from '@mui/icons-material/Done';
import packagesData from "../../JsonFiles/InstitutePackages.json";
import { useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { GetInstitutePackagesDetails } from "../../Actions/StudentA";
import { BaseUrl } from "../../Actions/Base";

const PackageSelectionDesign = ({setOpenSignupScreen, InstituteData, setInstituteData, instituteId, InstitutePackagesData}) => {
    const [isSelectedPackage, setIsSelectedPackage] = useState("")
    const [selectedPackage, setSelectedPackage] = useState("");
    const [error, setError] = useState("");
    const { packageId } = useParams(); // Get packageId from the URL
    console.log("packageId is:",packageId)
    const [isYearly, setIsYearly] = useState(false);

    const Dispatch = useDispatch();

    const toggleBilling = () => {
      setIsYearly((prev) => !prev);
    };


    // useEffect(() => {
    //     // When the component mounts, set the selected package from URL
    //     if (packageId) {
    //         const selectedPkg = packagesData.find(pkg => pkg.id === packageId);
    //         if (selectedPkg) {
    //             setSelectedPackage(selectedPkg.id);
    //             setInstituteData(prev => ({
    //                 ...prev,
    //                 package: {
    //                     id: selectedPkg.id,
    //                     name: selectedPkg.name,
    //                     price: selectedPkg.price,
    //                     annualDiscount: selectedPkg.annualDiscount,
    //                     originalPrice: selectedPkg.originalPrice,
    //                     features: selectedPkg.features,
    //                     PackageType: isYearly ? "Yearly" : "Monthly", // Add package type here
    //                 },
    //             }));
    //         }
    //     }
    // }, [packageId, setInstituteData, isYearly]);

    useEffect(() => {
        if (packageId && InstitutePackagesData?.length > 0) {
            const selectedPkg = InstitutePackagesData.find(pkg => pkg.PackageId === packageId);
            if (selectedPkg) {
                setSelectedPackage(selectedPkg.PackageId);
                setInstituteData(prev => ({
                    ...prev,
                    package: {
                        id: selectedPkg.PackageId,
                        name: selectedPkg.InstitutePackageName,
                        price: selectedPkg.price,
                        annualDiscount: selectedPkg.annualDiscount,
                        originalPrice: selectedPkg.originalPrice,
                        features: selectedPkg.features,
                        PackageType: isYearly ? "Yearly" : "Monthly",
                    },
                }));
            }
        }
    }, [packageId, InstitutePackagesData, setInstituteData, isYearly]);
    

    // const handlePackageSelect = (pkg) => {
    //     setSelectedPackage(pkg.id);
    //     setError(""); // Clear error if a package is selected
    //     setInstituteData((prev) => ({
    //         ...prev,
    //         package: {
    //             id: pkg.id,
    //             name: pkg.name,
    //             price: pkg.price,
    //             annualDiscount: pkg.annualDiscount,
    //             originalPrice: pkg.originalPrice,
    //             features: pkg.features,
    //             PackageType: isYearly ? "Yearly" : "Monthly", // Add package type here
    //         },
    //     }));
    // };

    const handlePackageSelect = (pkg) => {
        setSelectedPackage(pkg.PackageId);
        setError("");
        setInstituteData((prev) => ({
            ...prev,
            package: {
                id: pkg.PackageId,
                name: pkg.InstitutePackageName,
                price: pkg.price,
                annualDiscount: pkg.annualDiscount,
                originalPrice: pkg.originalPrice,
                features: pkg.features,
                PackageType: isYearly ? "Yearly" : "Monthly",
            },
        }));
    };
    
    const handleNext = () => {
        if (!selectedPackage) {
            setError("Please select a package before proceeding.");
            return;
        }
        setOpenSignupScreen("TermAndCondition");
    };

    return (
        <div className="w-full p-[20px] flex flex-col gap-[10px]">
             <p className=" w-full text-[60px] font-bold text-center">
             Subscription Plan
            </p>
            <p className=" w-full text-[26px] text-center">
            Choose the plan that best fits your institute’s needs.
            </p>

            <div className="w-full flex justify-center items-center gap-3">
                <span className={`text-sm font-medium ${!isYearly ? "text-[#A1A3F0]" : "text-black/40"}`}>
                    Monthly
                </span>
                <button
                    onClick={toggleBilling}
                    className={`w-12 h-6 rounded-full relative transition-colors duration-300 ${
                    isYearly ? "bg-[#A1A3F0]" : "bg-[#A1A3F0]"
                    }`}
                >
                    <span
                    className={`w-5 h-5 bg-white rounded-full absolute top-0.5 transition-all duration-300 ${
                        isYearly ? "right-0.5" : "left-0.5"
                    }`}
                    />
                </button>
                <span className={`text-sm font-medium ${isYearly ? "text-[#A1A3F0]" : "text-black/40"}`}>
                    Yearly
                </span>
            </div>

            <div className="w-full flex gap-[20px] justify-center items-center flex-wrap mt-[40px]">
                {InstitutePackagesData.map((pkg) => (
                    <div
                    key={pkg.PackageId}
                    className={`w-[400px] h-[860px] lg:h-[840px] rounded-[20px] pl-[30px] pt-[10px] pr-[10px] flex flex-col gap-[15px] ${
                        selectedPackage === pkg.PackageId
                        ? `bg-[${pkg.bgColorSelected}] text-[${pkg.textColorSelected}]`
                        : `bg-[${pkg.bgColor}] text-[${pkg.textColor}]`
                    }`}
                    style={{ border: "1px solid #BCBCBC" }}
                    >
                    {/* Header */}
                    <div className="flex items-center gap-[20px]">
                        {/* <img
                        src={selectedPackage === pkg.PackageId ? pkg.imageSelected : pkg.image}
                        alt={pkg.InstitutePackageName}
                        /> */}
                        <img
                        src={selectedPackage === pkg.PackageId ? `${BaseUrl}/api/images/InstitutePackages?url=${pkg.imageSelected}` : `${BaseUrl}/api/images/InstitutePackages?url=${pkg.image}`}
                        alt={pkg.InstitutePackageName}
                        />
                        <p className="text-[40px] lg:text-[50px] font-semibold leading-[50px]">
                        {pkg.InstitutePackageName}
                        </p>
                    </div>

                    {/* Features */}
                    {pkg.features.map((feature, index) => (
                        <div key={index} className="flex items-center gap-[20px] mt-[10px]">
                        <div className={`w-[30px] h-[30px] rounded-full flex justify-center items-center `}
                        style={{ backgroundColor: pkg.checkBoxBg }} >
                            <DoneIcon color="inherit" style={{ color: pkg.checkBoxTick }} />
                        </div>
                        <p
                            className={`text-[18px] ${
                            selectedPackage === pkg.PackageId ? "" : "font-semibold"
                            }`}
                        >
                            {feature}
                        </p>
                        </div>
                    ))}

                    {/* Pricing */}
                    <div className="w-full flex flex-col justify-center items-center gap-[10px] mt-[10px]">
                        <p
                        className={`text-[50px] font-semibold ${
                            selectedPackage === pkg.PackageId
                            ? `text-[${pkg.textColorSelected}]`
                            : `text-[${pkg.bgColorSelected}]`
                        }`}
                        >
                        {/* {pkg.price} */}
                        {isYearly ? pkg.AnnualPrice : pkg.price}
                        </p>
                        <p className="text-[22px] font-semibold">
                        {/* {pkg.annualDiscount} */}
                        {isYearly ? pkg.annualDiscount : pkg.monthlyDiscount}
                        </p>
                        <p
                        className={`text-[30px] font-semibold relative before:content-[''] before:absolute before:top-1/2 before:left-0 before:w-full before:h-[2px] before:-translate-y-1/2 ${
                            selectedPackage === pkg.PackageId
                            ? `text-[${pkg.textColorSelected}] before:bg-[${pkg.textColorSelected}]`
                            : `text-[${pkg.bgColorSelected}] before:bg-[${pkg.bgColorSelected}]`
                        }`}
                        >
                        {/* {pkg.originalPrice} */}
                        {isYearly ? pkg.originalAnnualPrice : pkg.originalPrice}
                        </p>
                    </div>

                    {/* Select Button */}
                    <div className="w-full flex justify-center mt-[15px]">
                        <button
                        className={`w-[80%] cursor-pointer rounded-[8px] border-none py-[15px] text-[18px] ${
                            selectedPackage === pkg.PackageId
                            ? `bg-[${pkg.textColorSelected}] text-[${pkg.bgColorSelected}]`
                            : `bg-[${pkg.bgColorSelected}] text-[${pkg.textColorSelected}]`
                        }`}
                         onClick={() => handlePackageSelect(pkg)}
                        >
                        {selectedPackage === pkg.PackageId ? "Selected" : "Select Package"}
                        </button>
                    </div>
                    </div>
                ))}
            </div>

            {/* Error Message */}
            {error && <p className="text-[#FF0000] text-center mt-[10px]">{error}</p>}

            <div className="w-full flex justify-center items-center mt-[20px]">
                        <button
                            className={`cursor-pointer rounded-[8px] border-none bg-primary  py-2
                                    text-[16px] text-white  xl:py-2 
                                        xl:text-[18px]     2xl:text-base w-[150px] h-[50px]`}
                                        onClick={handleNext}               
                                     >
                            Next
                        </button>
            </div>
        </div>
    );
}

export default PackageSelectionDesign;



            {/* <div className="w-full flex gap-[20px] justify-center items-center flex-wrap mt-[40px]">

                <div className={`w-[420px] h-[840px]    ${isSelectedPackage === "Package3" ? "bg-[#1A99A6] text-[#FFFFFF]" : "bg-[#FFFFFF]"
                            } rounded-[20px] pl-[30px] pt-[10px] pr-[10px] flex flex-col gap-[15px]`}
                style={{
                    border:"1px solid #BCBCBC"
                }}>
                    <div className="flex items-center gap-[20px]">
                        <img src={isSelectedPackage === "Package3" ? PayasugoWhite : Payasugo} alt="partner" />
                        <p className="text-[50px] font-semibold leading-[50px]">PayAsYouGo Partner</p>
                    </div>

                    <div className="flex items-center gap-[20px] mt-[10px]">
                        <div className="w-[30px] h-[30px] rounded-full flex justify-center items-center bg-[#D8F0F2]">
                                <DoneIcon color="inherit" style={{ color: "#1A99A6" }} />
                        </div>
                        <p className={`text-[18px] ${
                            isSelectedPackage === "Package3" ? "" : "font-semibold"
                            } `}>01 Admin Login</p>
                    </div>

                    <div className="flex items-center gap-[20px]">
                        <div className="w-[30px] h-[30px] rounded-full flex justify-center items-center bg-[#D8F0F2]">
                                <DoneIcon color="inherit" style={{ color: "#1A99A6" }} />
                        </div>
                        <p className={`text-[18px] ${
                            isSelectedPackage === "Package3" ? "" : "font-semibold"
                            } `}>02 Staff Login</p>
                    </div>

                    <div className="flex items-center gap-[20px]">
                        <div className="w-[30px] h-[30px] rounded-full flex justify-center items-center bg-[#D8F0F2]">
                                <DoneIcon color="inherit" style={{ color: "#1A99A6" }} />
                        </div>
                        <p className={`text-[18px] ${
                            isSelectedPackage === "Package3" ? "" : "font-semibold"
                            } `}>5 Instructors Login</p>
                    </div>

                    <div className="flex items-center gap-[20px]">
                        <div className="w-[30px] h-[30px] rounded-full flex justify-center items-center bg-[#D8F0F2]">
                                <DoneIcon color="inherit" style={{ color: "#1A99A6" }} />
                        </div>
                        <p className={`text-[18px] ${
                            isSelectedPackage === "Package3" ? "" : "font-semibold"
                            } `}>GPS Tracking Records</p>
                    </div>

                    <div className="flex items-center gap-[20px]">
                        <div className="w-[30px] h-[30px] rounded-full flex justify-center items-center bg-[#D8F0F2]">
                                <DoneIcon color="inherit" style={{ color: "#1A99A6" }} />
                        </div>
                        <p className={`text-[18px] ${
                            isSelectedPackage === "Package3" ? "" : "font-semibold"
                            } `}>In-Cabin Audio Recordings</p>
                    </div>

                    <div className="flex items-center gap-[20px]">
                        <div className="w-[30px] h-[30px] rounded-full flex justify-center items-center bg-[#D8F0F2]">
                                <DoneIcon color="inherit" style={{ color: "#1A99A6" }} />
                        </div>
                        <p className={`text-[18px] ${
                            isSelectedPackage === "Package3" ? "" : "font-semibold"
                            } `}>In-Cabin Video Recordings</p>
                    </div>

                    <div className="flex items-center gap-[20px]">
                        <div className="w-[30px] h-[30px] rounded-full flex justify-center items-center bg-[#D8F0F2]">
                                <DoneIcon color="inherit" style={{ color: "#1A99A6" }} />
                        </div>
                        <p className={`text-[18px] ${
                            isSelectedPackage === "Package3" ? "" : "font-semibold"
                            } `}>10 GB Space For Video Recordings</p>
                    </div>

                    <div className="flex items-center gap-[20px]">
                        <div className="w-[30px] h-[30px] rounded-full flex justify-center items-center bg-[#D8F0F2]">
                                <DoneIcon color="inherit" style={{ color: "#1A99A6" }} />
                        </div>
                        <p className={`text-[18px] ${
                            isSelectedPackage === "Package3" ? "" : "font-semibold"
                            } `}>Only $ 300 Activation Charges</p>
                    </div>

                    <div className="w-full flex flex-col justify-center items-center gap-[10px] mt-[10px]">
                         <p className={`text-[50px] font-semibold
                         ${
                            isSelectedPackage === "Package3" ? "text-[#FFFFFF]" : "text-[#1A99A6]"
                            } `}>$ 5000</p>
                         <p className="text-[22px] font-semibold">Annually: Save upto $ 250</p>
                         <p className={`text-[30px] font-semibold relative before:content-[''] before:absolute before:top-1/2 before:left-0 before:w-full before:h-[2px] before:-translate-y-1/2
                         ${
                            isSelectedPackage === "Package3" ? "text-[#FFFFFF] before:bg-[#FFFFFF]" : "text-[#1A99A6] before:bg-[#1A99A6]"
                            }`}>
                                $ 6000
                         </p>
                    </div>

                    <div className="w-full flex justify-center mt-[15px]">
                        <button
                         className={`w-[80%] cursor-pointer rounded-[8px] border-none py-[15px] text-[18px] ${
                            isSelectedPackage === "Package3" ? "bg-[#FFFFFF] text-[#1A99A6]" : "bg-[#1A99A6] text-[#FFFFFF]"
                            }`}
                            onClick={()=>setIsSelectedPackage("Package3")}
                        >
                            {isSelectedPackage==="Package3" ? "Selected" : "Select Package"}
                        </button>
                    </div>
                </div>

                <div className={`w-[350px] h-[840px]
                ${isSelectedPackage === "Package2" ? "bg-[#7D31FA] text-[#FFFFFF]" : "bg-[#FFFFFF]"
                            } rounded-[20px] pl-[30px] pt-[10px] pr-[10px] flex flex-col gap-[15px]`}
                style={{
                    border:"1px solid #BCBCBC"
                }}>
                    <div className="flex items-center gap-[20px]">
                        <img src={isSelectedPackage === "Package2" ? AssociatepartnerWhite : Associatepartner} alt="partner" />
                        <p className="text-[50px] font-semibold leading-[50px]">Associate Partner</p>
                    </div>

                    <div className="flex items-center gap-[20px] mt-[10px]">
                        <div className="w-[30px] h-[30px] rounded-full flex justify-center items-center bg-[#EADDFF]">
                                <DoneIcon color="inherit" style={{ color: "#7D31FA" }} />
                        </div>
                        <p className={`text-[18px] ${
                            isSelectedPackage === "Package2" ? "" : "font-semibold"
                            } `}>03 Admin Login</p>
                    </div>

                    <div className="flex items-center gap-[20px]">
                        <div className="w-[30px] h-[30px] rounded-full flex justify-center items-center bg-[#EADDFF]">
                                <DoneIcon color="inherit" style={{ color: "#7D31FA" }} />
                        </div>
                        <p className={`text-[18px] ${
                            isSelectedPackage === "Package2" ? "" : "font-semibold"
                            } `}>05 Staff Login</p>
                    </div>

                    <div className="flex items-center gap-[20px]">
                        <div className="w-[30px] h-[30px] rounded-full flex justify-center items-center bg-[#EADDFF]">
                                <DoneIcon color="inherit" style={{ color: "#7D31FA" }} />
                        </div>
                        <p className={`text-[18px] ${
                            isSelectedPackage === "Package2" ? "" : "font-semibold"
                            } `}>10 Instructors Login</p>
                    </div>

                    <div className="flex items-center gap-[20px]">
                        <div className="w-[30px] h-[30px] rounded-full flex justify-center items-center bg-[#EADDFF]">
                                <DoneIcon color="inherit" style={{ color: "#7D31FA" }} />
                        </div>
                        <p className={`text-[18px] ${
                            isSelectedPackage === "Package2" ? "" : "font-semibold"
                            } `}>GPS Tracking Records</p>
                    </div>

                    <div className="flex items-center gap-[20px]">
                        <div className="w-[30px] h-[30px] rounded-full flex justify-center items-center bg-[#EADDFF]">
                                <DoneIcon color="inherit" style={{ color: "#7D31FA" }} />
                        </div>
                        <p className={`text-[18px] ${
                            isSelectedPackage === "Package2" ? "" : "font-semibold"
                            } `}>In-Cabin Audio Recordings</p>
                    </div>

                    <div className="flex items-center gap-[20px]">
                        <div className="w-[30px] h-[30px] rounded-full flex justify-center items-center bg-[#EADDFF]">
                                <DoneIcon color="inherit" style={{ color: "#7D31FA" }} />
                        </div>
                        <p className={`text-[18px] ${
                            isSelectedPackage === "Package2" ? "" : "font-semibold"
                            } `}>In-Cabin Video Recordings</p>
                    </div>

                    <div className="flex items-center gap-[20px]">
                        <div className="w-[30px] h-[30px] rounded-full flex justify-center items-center bg-[#EADDFF]">
                                <DoneIcon color="inherit" style={{ color: "#7D31FA" }} />
                        </div>
                        <p className={`text-[18px] ${
                            isSelectedPackage === "Package2" ? "" : "font-semibold"
                            } `}>10 GB Space For Video Recordings</p>
                    </div>

                    <div className="flex items-center gap-[20px]">
                        <div className="w-[30px] h-[30px] rounded-full flex justify-center items-center bg-[#EADDFF]">
                                <DoneIcon color="inherit" style={{ color: "#7D31FA" }} />
                        </div>
                        <p className={`text-[18px] ${
                            isSelectedPackage === "Package2" ? "" : "font-semibold"
                            } `}>Only $ 300 Activation Charges</p>
                    </div>

                    <div className="w-full flex flex-col justify-center items-center gap-[10px]">
                         <p className={`text-[50px] font-semibold
                         ${
                            isSelectedPackage === "Package2" ? "text-[#FFFFFF]" : "text-[#7D31FA]"
                            } `}>$ 1500</p>
                         <p className="text-[22px] font-semibold">Annually: Save upto $ 250</p>
                         <p className={`text-[30px] font-semibold relative before:content-[''] before:absolute before:top-1/2 before:left-0 before:w-full before:h-[2px] before:-translate-y-1/2
                         ${
                            isSelectedPackage === "Package2" ? "text-[#FFFFFF] before:bg-[#FFFFFF]" : "text-[#7D31FA] before:bg-[#7D31FA]"
                            }`}>
                                $ 1750
                         </p>
                    </div>

                    <div className="w-full flex justify-center mt-[15px]">
                        <button
                         className={`w-[80%] cursor-pointer rounded-[8px] border-none py-[15px] text-[18px] ${
                            isSelectedPackage === "Package2" ? "bg-[#FFFFFF] text-[#7D31FA]" : "bg-[#7D31FA] text-[#FFFFFF]"
                            }`}
                            onClick={()=>setIsSelectedPackage("Package2")}
                        >
                            {isSelectedPackage==="Package2" ? "Selected" : "Select Package"}
                        </button>
                    </div>
                </div>

                <div className={`w-[350px] h-[840px] ${
                            isSelectedPackage === "Package1" ? "bg-[#F08F1A] text-[#FFFFFF]" : "bg-[#FFFFFF]"
                            } rounded-[20px] pl-[30px] py-[30px] pr-[10px] flex flex-col gap-[15px]`}
                    style={{
                        border:"1px solid #BCBCBC"
                    }}>
                    <div className="flex items-center gap-[20px]">
                        <img src={isSelectedPackage === "Package1" ? PartnerImageWhite : PartnerImage} alt="partner" />
                        <p className={`text-[50px] font-semibold} `}>Partner</p>
                    </div>

                    <div className="flex items-center gap-[20px] mt-[20px]">
                        <div className="w-[30px] h-[30px] rounded-full flex justify-center items-center bg-[#FBF4E8]">
                                <DoneIcon color="inherit" style={{ color: "#F0901B" }} />
                        </div>
                        <p  className={`text-[18px] ${
                            isSelectedPackage === "Package1" ? "" : "font-semibold"
                            } `}>Unlimited Active Students</p>
                    </div>

                    <div className="flex items-center gap-[20px]">
                        <div className="w-[30px] h-[30px] rounded-full flex justify-center items-center bg-[#FBF4E8]">
                                <DoneIcon color="inherit" style={{ color: "#F0901B" }} />
                        </div>
                        <p className={`text-[18px] ${
                            isSelectedPackage === "Package1" ? "" : "font-semibold"
                            } `}>Unlimited Admin Login</p>
                    </div>

                    <div className="flex items-center gap-[20px]">
                        <div className="w-[30px] h-[30px] rounded-full flex justify-center items-center bg-[#FBF4E8]">
                                <DoneIcon color="inherit" style={{ color: "#F0901B" }} />
                        </div>
                        <p className={`text-[18px] ${
                            isSelectedPackage === "Package1" ? "" : "font-semibold"
                            } `}>Unlimited Staff Login</p>
                    </div>

                    <div className="flex items-center gap-[20px]">
                        <div className="w-[30px] h-[30px] rounded-full flex justify-center items-center bg-[#FBF4E8]">
                                <DoneIcon color="inherit" style={{ color: "#F0901B" }} />
                        </div>
                        <p className={`text-[18px] ${
                            isSelectedPackage === "Package1" ? "" : "font-semibold"
                            } `}>GPS Tracking Records</p>
                    </div>

                    <div className="flex items-center gap-[20px]">
                        <div className="w-[30px] h-[30px] rounded-full flex justify-center items-center bg-[#FBF4E8]">
                                <DoneIcon color="inherit" style={{ color: "#F0901B" }} />
                        </div>
                        <p className={`text-[18px] ${
                            isSelectedPackage === "Package1" ? "" : "font-semibold"
                            } `}>In-Cabin Video Recordings</p>
                    </div>

                    <div className="flex items-center gap-[20px]">
                        <div className="w-[30px] h-[30px] rounded-full flex justify-center items-center bg-[#FBF4E8]">
                                <DoneIcon color="inherit" style={{ color: "#F0901B" }} />
                        </div>
                        <p className={`text-[18px] ${
                            isSelectedPackage === "Package1" ? "" : "font-semibold"
                            } `}>Unlimited Admin Login</p>
                    </div>

                    <div className="flex items-center gap-[20px]">
                        <div className="w-[30px] h-[30px] rounded-full flex justify-center items-center bg-[#FBF4E8]">
                                <DoneIcon color="inherit" style={{ color: "#F0901B" }} />
                        </div>
                        <p className={`text-[18px] ${
                            isSelectedPackage === "Package1" ? "" : "font-semibold"
                            } `}>Unlimited Space For Video Recordings</p>
                    </div>

                    <div className="flex items-center gap-[20px]">
                        <div className="w-[30px] h-[30px] rounded-full flex justify-center items-center bg-[#FBF4E8]">
                                <DoneIcon color="inherit" style={{ color: "#F0901B" }} />
                        </div>
                        <p className={`text-[18px] ${
                            isSelectedPackage === "Package1" ? "" : "font-semibold"
                            } `}>Only $ 300 Activation Charges</p>
                    </div>

                    <div className="w-full flex flex-col justify-center items-center gap-[10px]">
                         <p className={`text-[50px] font-semibold ${
                            isSelectedPackage === "Package1" ? "text-[#FFFFFF]" : "text-[#F08F1A]"
                            } `}>$ 1000</p>
                         <p className="text-[22px] font-semibold">Pay 35% of Revenue</p>
                         <p className={`text-[30px] font-semibold relative before:content-[''] before:absolute before:top-1/2 before:left-0 before:w-full before:h-[2px] before:bg-[#F08F1A] before:-translate-y-1/2 
                         ${
                            isSelectedPackage === "Package1" ? "text-[#FFFFFF] before:bg-[#FFFFFF]" : "text-[#F08F1A] before:bg-[#F08F1A]"
                            }`}
                         >
                                $ 1250
                         </p>
                    </div>

                    <div className="w-full flex justify-center mt-[15px]">
                        <button
                            className={`w-[80%] cursor-pointer rounded-[8px] border-none py-[15px] text-[18px] ${
                            isSelectedPackage === "Package1" ? "bg-[#FFFFFF] text-[#F08F1A]" : "bg-[#F08F1A] text-[#FFFFFF]"
                            }`}
                            onClick={()=>setIsSelectedPackage("Package1")}
                        >
                            {isSelectedPackage==="Package1" ? "Selected" : "Select Package"}
                        </button>
                    </div>
                </div>
               
            </div> */}